/*
PURPOSE: Environment-aware logging utility for frontend application

USE CASES:
- Controlled logging that is silent in production
- Consistent logging API matching backend Logger
- Debug-level logging for complex troubleshooting

USAGE:
- logger.debug() - Only in development when localStorage.DEBUG is set
- logger.info() - Development only, for important flow information
- logger.warn() - Always logs, for potential issues
- logger.error() - Always logs, for actual errors

ASSUMPTIONS:
- Production builds set import.meta.env.PROD = true
- Development uses import.meta.env.DEV = true
- Debug mode enabled via localStorage.setItem('DEBUG', 'true')
*/

// Trigger deploy

class Logger {
  private static isDevelopment(): boolean {
    return process.env.NODE_ENV === 'development';
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static info(message: string, ...optionalParams: any[]): void {
    if (this.isDevelopment()) {
      console.log(`INFO: ${message}`, ...optionalParams);
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static debug(message: string, ...optionalParams: any[]): void {
    if (this.isDevelopment() && localStorage.getItem('DEBUG')) {
      console.debug(`DEBUG: ${message}`, ...optionalParams);
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static warn(message: string, ...optionalParams: any[]): void {
    console.warn(`WARN: ${message}`, ...optionalParams);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static error(message: string, ...optionalParams: any[]): void {
    console.error(`ERROR: ${message}`, ...optionalParams);
  }
}

export default Logger;
